import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './app';
import * as serviceWorker from './serviceWorker';
import Backend, { BackendContext } from './shared/services/Backend';

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) si usas TypeScript
root.render(
    <BackendContext.Provider value={Backend.getInstance()}>
        <App />
    </BackendContext.Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
